import React from 'react'

import { COACHING_TASK_TYPE } from '@/reducers/tasks/tasks.constants'
import { NotesPanel } from '@/components/notes/NotesPanel'

/**
 * Thin adapter that renders the unified NotesPanel for a task drawer.
 * Kept as a separate component because TaskComments has a stable
 * external surface used by several inbox drawers (TaskDrawer,
 * PromptFeedbackDrawer, CustomerFeedbackDrawer) — the consumer-facing
 * prop shape stays the same; only the rendering swaps from the legacy
 * Comments + per-surface action creators to the unified flow.
 *
 * The compose box shows directly (collapsible={false}) and auto-saves a
 * draft on drawer close (saveOnUnmount), matching the legacy Comments
 * behavior. The placeholder is coaching/compliance-aware.
 */
export const TaskComments = ({ taskId, organizationId, taskType }) => {
  if (!taskId) {
    return null
  }

  const placeholder =
    taskType === COACHING_TASK_TYPE
      ? 'Write a coaching note for your agent'
      : 'Enter a brief summary of your review, including any necessary notes for your records'

  return (
    <NotesPanel
      anchor={{ noteType: 'task', id: taskId }}
      organizationId={organizationId}
      compact
      collapsible={false}
      placeholder={placeholder}
      saveOnUnmount
    />
  )
}
